module.exports = __webpack_public_path__ + "static/media/about-certificate-img6.dac0af8b.jpg";